<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="user-panel" *ngIf="user">
    <div class="user-notification" *ngIf="(userProfileData && (userProfileData?.alertType === 'SYS' || userProfileData?.alertType === 'DES')) ? true : false" (click)='routeToAlertWindow();'>
        <span *ngIf='(alertCount > 0) ? true : false' class="circle">{{alertCount}}</span>
        <span *ngIf='showWarningIcon' class="alert-warning"></span>
        <img [src]="bellIconPath" alt="" />
    </div>
    <div class="user-info" (click)="userProfile.toggle($event)">
        <span class="user-name">{{user.firstName}} {{user.lastName}} </span>
        <span class="user-racf">({{user.racfId}})</span>
        <span *ngIf="(userProfileData && userProfileData?.alertType === 'DES')" class=""> |  {{appUtilService.getDeskNameById(userProfileData.alertDesk)}}</span>
        <div id="userProfileIcon" class="fa fa-caret-down" (keyup.space)='$event.preventDefault();' (keyup.spacebar)='$event.preventDefault();' (keydown.spacebar)='showUserProfilePopup();' (keydown.space)='showUserProfilePopup();' tabindex="{{tabLevel}}" (blur)="setFocusBacktoStart();"></div>

    </div>
    <p-overlayPanel #userProfile class="user-profile-overlay">
        <p class="normal-line-height user-profile-links" (click)='showUserProfilePopup(); userProfile.hide();'>User Profile</p>
    </p-overlayPanel>
    <div class="desk-info">

    </div>
    <div class="alert-pop" *ngIf='selectedTab?.type === "Alerts" || (userProfileData && userProfileData?.alertType === "NON") ? false : true'>
        <div class='alerts-list {{alert.showLoader ? "alertShowLoader" : ""}}' *ngFor='let alert of alerts' (click)='alert.showLoader = true; closeThisAlert(alert);'>
            <div class="alert-item">
                <span class="alertIcon"></span>
                <span>{{appUtilService.formatLocomotiveIdForDispaly(alert.locoId)}}</span>
                <span>{{alert.trainId}}</span>
                <span>{{alert.terminal}}</span>
                <span>{{alert.description}}</span>
                <span class="closeAlertIcon" (click)='alert.showLoader = true; closeThisAlert(alert);'> x </span>
            </div>
        </div>
    </div>
</div>